// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1Yw4Xu","totalRow":"_2vLG3d","discount":"_2bgx9G","total":"_2me8C5","additionalInfo":"_3_TG9U","accentText":"I9EWH7","footerContainer":"_3q4shS"};